import { PopularSearchTextByTypeCard } from './PopularSearchTextSection'
import { withPopularTextSearchSection } from './withPopularSearchTextSection'

const ConnectedStory = withPopularTextSearchSection(PopularSearchTextByTypeCard)

export { ConnectedStory as PopularSearchTextByTypeCard }
